<template>
  <div class="container">
    <el-tabs v-model="status" type="card" @tab-click="handleClick">
      <el-tab-pane :label="`已登记(${counts.registered})`" name="1"></el-tab-pane>
      <el-tab-pane :label="`已废弃(${counts.discard})`" name="2"></el-tab-pane>
    </el-tabs>
    <RepairRecordForm :repairOptions="RepairOptionEnum" @search="search"></RepairRecordForm>
    <div style="display: flex;margin-bottom: 10px;">
      <el-button type="primary" @click="handleExport">批量导出</el-button>
    </div>
    <WmsTable rowKey="repairCode" is-row-selection @selectChange="selectChangeCall" :isPagination="query"
      :columns="columns" :dataSource="dataSource" :preserveSelectedRowKeys="false" @pageChange="pageChangeCall"
      :hasHeader="false">
      <div slot="imgsBeforeList" slot-scope="{text}">
        <ImgPreviews :images="text" />
      </div>
      <div slot="imgsAfterList" slot-scope="{text}">
        <ImgPreviews :images="text" />
      </div>
      <div slot="action" slot-scope="{text, record}" v-if="status === '1'">
        <el-link type="primary" @click="edit(record)">编辑</el-link> |
        <el-link @click="handleDiscard(record)" type="danger">废弃</el-link>
      </div>
    </WmsTable>
    <el-dialog :visible="visible" title="编辑修复内容" width="800px" @close="visible = false">
      <el-form ref="editData" style="text-align: left;" :model="editData" :rules="rules" inline label-position="left">
        <el-form-item label="修复项" prop="optionCode">
          <el-select disabled v-model="editData.optionCode" placeholder="请选择">
            <el-option v-for="item in RepairOptionEnum" :key="item.code" :label="item.name"
              :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="修复程度" prop="severityCode" :rules="[
          { required: true, message: '请选择', trigger: 'blur' },
        ]">
          <el-select v-model="editData.severityCode" placeholder="请选择">
            <el-option v-for="item in problemTypes" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="修复件数" prop="nums" :rules="[
          { required: true, message: '请输入', trigger: 'blur' },
        ]">
          <el-input-number :min="1" v-model="editData.nums" placeholder="请输入"></el-input-number>
        </el-form-item>
        <br />
        <el-form-item label="修复前照片" prop="imgsBeforeList" :rules="[
          { required: true, message: '请输入', trigger: 'blur' },
        ]">
          <form-upload v-model="editData.imgsBeforeList" :limit="10" path="wms/repair/" bizType="wmsRepairImage">
          </form-upload>
        </el-form-item>
        <br />
        <el-form-item label="修复后照片" prop="imgsAfterList" :rules="[
          { required: true, message: '请输入', trigger: 'blur' },
        ]">
          <form-upload v-model="editData.imgsAfterList" :limit="10" path="wms/repair/" bizType="wmsAbnormalImage">
          </form-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="margin-left: 30px" type="primary" @click="sure">确定</el-button>
        <el-button style="margin-left: 10px" @click="cancel">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Modal } from 'ant-design-vue';
import RepairRecordForm from './components/RepairRecordForm.vue';
import { statusCount } from '@/apis/repairRecord'
import { getRepairOptionEnum, repairRecordDiscard, repairRecordUpdate, repairRecordPage, repairRecordExport } from '@/apis/repairRecord';
export default {
  components: {
    RepairRecordForm
  },
  data() {
    return {
      RepairOptionEnum: [],
      counts: {
        'registered': 0,
        'discard': 0
      },
      visible: false,
      editData: {},
      status: '1',
      countData: {},
      dataSource: [],
      selRow: [],
      rules: {

      },
      problemTypes: [{
        value: 'lightly',
        label: "轻度"
      }, {
        value: 'medium',
        label: "中度"
      }, {
        value: 'serious',
        label: "重度"
      }],
      query: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      formInline: {},
      columns: [
        {
          title: "#",
          dataIndex: "id",
          width: 50,
          fixed: 'left',
          customRender: (text, record, index) => {
            return index + 1;
          },
        }, {
          title: "修复ID",
          dataIndex: "repairCode",
          width: 160,
        }, {
          title: "批次号",
          dataIndex: "pkgCode",
          width: 140,
        }, {
          title: "修复项",
          dataIndex: "optionName",
          width: 100,
        }, {
          title: "程度",
          dataIndex: "severityCode",
          width: 80,
          customRender: (text) => {
            return this.problemTypes.find(item => item.value === text)?.label
          }
        }, {
          title: "修复件数",
          dataIndex: "nums",
          width: 90,
        }, {
          title: "修复前照片",
          dataIndex: "imgsBeforeList",
          scopedSlots: {
            customRender: "imgsBeforeList",
          },
        }, {
          title: "修复后照片",
          dataIndex: "imgsAfterList",
          scopedSlots: {
            customRender: "imgsAfterList",
          },
        }, {
          title: "修复人",
          dataIndex: "repairer",
          width: 100,
        }, {
          title: "修复时间",
          dataIndex: "repairTime",
        }, {
          title: "操作",
          width: 120,
          fixed: "right",
          scopedSlots: {
            customRender: "action",
          },
        }
      ]
    }
  },
  async created() {
    const res = await getRepairOptionEnum()
    this.RepairOptionEnum = res.data
    this.getCountsData()
    this.getList()
  },
  methods: {
    selectChangeCall: function (rows) {
      this.selRow = rows
    },
    /** 选中数据导出 */
    async handleExport() {
      this.$confirm('请确认是否导出数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        if (this.selRow.length === 0) {
          await repairRecordExport({ ...this.query, pageNum: this.query.current, status: this.status, ...this.formInline })
        } else {
          await repairRecordExport({ repairCodeList: this.selRow.map(item => item.repairCode) })
        }
        this.$message.success('导出成功')
      })
    },
    handleDiscard(record) {
      this.$confirm('请确认是否废弃?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await repairRecordDiscard({ repairCode: record.repairCode })
        this.$message.success('废弃成功')
        this.search(this.formInline)
        this.getCountsData()
      })
    },
    async sure() {
      this.$refs.editData.validate(async (valid) => {
        if (valid) {
          console.log(this.editData);

          const res = await repairRecordUpdate({
            ...this.editData,
          })
          if (res.code == 0) {
            this.$message.success('提交成功')
            this.visible = false
            this.search(this.formInline)
          }

        } else {
          return false
        }
      })

    },
    cancel() {
      this.visible = false
      this.editData = {}
    },
    /** 获取状态数据 */
    getCountsData() {
      statusCount().then(res => {
        this.counts = res.data
      })
    },
    /** 切换 tab */
    handleClick(tab, event) {
      this.search(this.formInline)
      this.getCountsData()
    },
    search(params) {
      this.formInline = params
      this.query = {
        pageSize: 10,
        current: 1,
        total: 0
      }
      this.getList();
    },
    getList() {
      repairRecordPage({ ...this.query, pageNum: this.query.current, status: +this.status, ...this.formInline }).then(({ code, data }) => {
        if (code == 0) {
          console.log(data, 'data');

          this.dataSource = data.records;
          this.query.total = data.total;
        }
      });
    },
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getList();
    },
    /** 批量导出 */
    moreExport() {
      Modal.confirm({
        title: '提示',
        content: '确认导出？',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          this.$message.success('请前往报表-数据导出中下载表格')
        },
        onCancel: () => {
          this.$message.info('取消导出')
        },
      });
    },
    /** 编辑 */
    edit(record) {
      this.editData = JSON.parse(JSON.stringify(record))
      this.visible = true
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  padding: 0 10px;
}
</style>